import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DeviceCategory } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class DetectDeviceService {
  deviceCategory: any = DeviceCategory;
  currentDevice: BehaviorSubject<DeviceCategory> = new BehaviorSubject(
    this.deviceCategory.DESKTOP
  );
  constructor(private deviceService: DeviceDetectorService) {
    this.getDeviceInfo();
  }

  public getDeviceInfo(): void {
    if (this.deviceService.isMobile()) {
      this.currentDevice.next(this.deviceCategory.DESKTOP);
    }
    if (this.deviceService.isTablet() || this.deviceService.isMobile()) {
      this.currentDevice.next(this.deviceCategory.TABLET_MOBILE);
    }
  }

  public getCurrentDevice(): Observable<any> {
    return this.currentDevice.asObservable();
  }
}
